import React, {useState} from "react";
import {Redirect} from "react-router";
import SideMenu from "./sideMenu/SideMenu";
import ManagementUnits from "./tableContext/managementUnits/Main";
import Measures from "./tableContext/measures/Main";
import Schedule from "./tableContext/schedule/Main";
import WorkPlans from "./tableContext/workPlans/Main";
import Performance from "./tableContext/performance/Main";
import SideMenuBottom from "./sideMenu/SideMenuBottom";
import SideMenuProcess from "./sideMenu/SideMenuProcess";
import SideMenuProcessErrorModal from "./sideMenu/SideMenuProcessErrorModal";
import Budget from "./tableContext/budget/Main";
import WorkOrder from "./tableContext/workOrder/Main";
import Obligations from "./tableContext/obligations/Main";
import MySwitchButton from "../common/button/switch-button/SwitchButton";

const ManagementMaintenance = (props) => {
    let compont;
    var tab = props.location.componentName;
    var treekey;
    // useEffect(async () => {
    //   try {
    //     const accessTokenRequest = {
    //       scopes: ["user.read", "openid", "profile"],
    //     };
    //     var accessToken = null;
    //     try {
    //       accessToken = await msalAuth
    //         .acquireTokenSilent(accessTokenRequest)
    //         .then((response) => {
    //           window.$mm_management_units_token = response.idToken.rawIdToken;
    //         });
    //     } catch (error) {
    //       console.log("AquireTokenSilent failure");
    //       console.log(error);
    //       accessToken = await msalAuth
    //         .acquireTokenRedirect(accessTokenRequest)
    //         .then((response) => {
    //           // get access token from response
    //           // response.accessToken
    //           window.$mm_management_units_token = response.idToken.rawIdToken;
    //         })
    //         .catch((err) => {
    //           // handle error
    //           console.log(err);
    //         });
    //     }

    //     if (window.$mm_management_units_token) {
    //       var user = await msalAuth.getAccount();
    //       await setUser(user);
    //     } else {
    //     }
    //   } catch (err) {
    //     var error = {};
    //     if (typeof err === "string") {
    //       var errParts = err.split("|");
    //       error =
    //         errParts.length > 1
    //           ? { message: errParts[1], debug: errParts[0] }
    //           : { message: err };
    //     } else {
    //       error = {
    //         message: err.message,
    //         debug: JSON.stringify(err),
    //       };
    //     }
    //   }
    // });

    if (
        props.history.location.pathname.split("/")[2] !=
        props.location.componentName
    ) {
        tab = props.history.location.pathname.split("/")[2];
    }
    switch (tab) {
        case "management-units":
            compont = <ManagementUnits {...props}/>;
            treekey = "beheereenheden";
            break;
        case "measures":
            compont = <Measures {...props} />;
            treekey = "maatregelen";
            break;
        case "schedule":
            compont = <Schedule {...props} />;
            treekey = "maatregelen";
            break;
        case "work-plans":
            compont = <WorkPlans {...props} />;
            treekey = "werkplannen";
            break;
        case "performance":
            compont = <Performance {...props} />;
            treekey = "werkplannen";
            break;
        case "budget":
            compont = <Budget {...props} />;
            treekey = "budget";
            break;
        case "workorder":
            compont = <WorkOrder {...props} />;
            break;
        case "obligations":
            compont = <Obligations {...props} />;
            break;
        default:
            return <Redirect to="/management-maintenance/management-units"/>;
    }

    return (
        <div>
                {compont && <div style={{display: "flex", marginBottom: "-40px"}}>
                <div style={{flexGrow: 1}}/>
                <div>
                    <MySwitchButton
                        initialText={"Toon selectie"}
                        selectedText={"Toon alles"}
                        onClick={()=>window.$mm_setShowSelectedButtonOnClick()}
                        onToggleState={() => {
                            window.$mm_setShowSelectedButtonToggleState = !window.$mm_setShowSelectedButtonToggleState;
                        }}
                        turnOff={(off)=>{
                            window.$mm_setShowSelectedButtonOff = () => {
                                window.$mm_setShowSelectedButtonToggleState = false;
                                off();
                            }
                        }}
                    />
                </div>
            </div>}

            <div className="mt-5">
                <div className="clearfix">
                    <div className="float-left w-30" id="menu-left">
                        <SideMenu
                            menuName="management-maintenance"
                            tabName={tab}
                            treekey={treekey}
                        />
                        <SideMenuProcess/>
                        <SideMenuProcessErrorModal/>
                        <SideMenuBottom/>
                    </div>
                    <div className="float-left ml-5 w-70" id="content-mid">
                        {compont}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ManagementMaintenance;
